export default {
  GAE_ENDPOINT: {
    BASE_URL: 'https://api.pagehits.io/',
    MEDIA_URL: 'https://cdn.pagehits.io/',
  },
  STRIPE: {
    API_KEY: 'pk_live_hI16r2C5o9jDJrF2w8Zo515A',
  },

  OAUTH: {
    GOOGLE: {
      AUTH_ENDPOINT: 'https://accounts.google.com/o/oauth2/v2/auth',
      CLIENT_ID: '959646433206-pqmr6l62t52u2k2v8tt240hfcnoc5hkl.apps.googleusercontent.com',
      REDIRECT_URI: 'https://app.pagehits.io/oauth/google',
    },
    FACEBOOK: {
      AUTH_ENDPOINT: 'https://www.facebook.com/v7.0/dialog/oauth',
      CLIENT_ID: '1101636293230607',
      REDIRECT_URI: 'https://app.pagehits.io/oauth/facebook',
    },
  },

  ANALYTICS: {
    MIXPANEL: { TOKEN: 'b96197fcfab0a9dee1875cf21c1b41e5' },
    GOOGLE: { TRACKING_ID: 'UA-78471807-3' },
  },

};



// WEBPACK FOOTER //
// ../config/params.prod.js